import angular from 'angular';
import { CoreModule } from '../core/core.module';
import { AccountModule } from './account/account.module';
import { AdpConfigModule } from './adp-config/adp-config.module';
import { AuditingModule } from './auditing/auditing.module';
import { configureCurrencyFormat } from './blocks/currency-format.config';
import { configureGlobalWindow } from './blocks/global-window.config';
import { configureUibTooltip } from './blocks/uib-tooltip.config';
import { BulletinsModule } from './bulletins/bulletins.module';
import { CommissionPolicyModule } from './commission-policy/commission-policy.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DivisionModule } from './division/division.module';
import { EmploymentProcessingModule } from './employment-processing/employment-processing.module';
import { EventHostModule } from './event-host/event-host.module';
import { EventsCoordinationModule } from './events-coordination/events-coordination.module';
import { EventsSchedulingModule } from './events-scheduling/events-scheduling.module';
import { HomeModule } from './home/home.module';
import { IcdCorporationManagerModule } from './icd-corporation-manager/icd-corporation-manager.module';
import { IcdCorporationModule } from './icd-corporation/icd-corporation.module';
import { InquiryAnalyticsModule } from './inquiry-analytics/inquiry-analytics.module';
import { LeadsModule } from './leads/leads.module';
import { LegalNoticeModule } from './legal-notice/legal-notice.module';
import { MainAppRoutingModule } from './main-app-routing.module';
import { MainAppComponent } from './main-app.component';
import { OnboardingModule } from './onboarding/onboarding.module';
import { PayoutModule } from './payout/payout.module';
import { PayrollFinancialsModule } from './payroll-financials/payroll-financials.module';
import { PayrollInvoicingModule } from './payroll-invoicing/payroll-invoicing.module';
import { PayrollModule } from './payroll/payroll.module';
import { ProductModule } from './product/product.module';
import { ReportJobsModule } from './report-jobs/report-jobs.module';
import { RogersDashboardModule } from './rogers-dashboard/rogers-dashboard.module';
import { RosterModule } from './roster/roster.module';
import { RsPayoutTransferModule } from './rs-payout-transfer/rs-payout-transfer.module';
import { SecurityModule } from './security/security.module';
import { SharedModule } from './shared/shared.module';
import { StateProvinceModule } from './state-province/state-province.module';
import { TaxNoticeModule } from './tax-notice/tax-notice.module';
import { OnboardingDocumentModule } from './onboarding-document/onboarding-document.module';
import { TeamModule } from './team/team.module';
import { TimeEntryModule } from './time-entry/time-entry.module';
import { WorkOrderModule } from './work-order/work-order.module';

export const MainAppModule: string = angular
    .module("apex.mainApp", [
        // Application modules
        CoreModule,
        MainAppRoutingModule,
        SharedModule,

        // Feature modules
        AccountModule,
        AdpConfigModule,
        AuditingModule,
        BulletinsModule,
        CommissionPolicyModule,
        DashboardModule,
        DivisionModule,
        EmploymentProcessingModule,
        EventHostModule,
        EventsCoordinationModule,
        EventsSchedulingModule,
        HomeModule,
        IcdCorporationManagerModule,
        IcdCorporationModule,
        InquiryAnalyticsModule,
        LeadsModule,
        LegalNoticeModule,
        OnboardingModule,
        OnboardingDocumentModule,
        PayoutModule,
        PayrollFinancialsModule,
        PayrollInvoicingModule,
        PayrollModule,
        ProductModule,
        ReportJobsModule,
        RogersDashboardModule,
        RosterModule,
        RsPayoutTransferModule,
        SecurityModule,
        StateProvinceModule,
        TaxNoticeModule,
        TeamModule,
        TimeEntryModule,
        WorkOrderModule
    ])
    .component("apexApp", MainAppComponent)
    .run(configureGlobalWindow)
    .run(configureCurrencyFormat)
    .config(configureUibTooltip)
    .name;
